import React from 'react'
import { useSelector } from 'react-redux'
import classNames from 'classnames'

import { getHasOpenDialogs } from '~/store/duck/dialogs'

import { AgentChat } from './chat'

import styles from './AgentChatPanel.module.scss'

interface AgentChatContentProps {}

const AgentChatContent: React.FC<AgentChatContentProps> = () => {
  const isModalOpen = useSelector(getHasOpenDialogs)

  return (
    <div
      className={classNames(
        styles.chatContent,
        isModalOpen && styles.modalOpen,
      )}
    >
      <AgentChat />
    </div>
  )
}

export default AgentChatContent
